<template>
  <mdb-container style="width:420px;" id="advertisementPreview">
    <mdb-btn
      data-html2canvas-ignore="true"
      @click="windowPrint"
      color="primary"
      size="sm"
      >{{ $t("advertisement_preview_save") }}</mdb-btn
    >
    <CouponPreview />
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbBtn } from "mdbvue";
import CouponPreview from "../components/CouponPreview.vue";

export default {
  name: "AdvertisementPreview",
  components: {
    mdbContainer,
    mdbBtn,
    CouponPreview
  },
  methods: {
    windowPrint() {
      //this.printHtml2Canvas("advertisementPreview");
      this.printHtml2Pdf("advertisementPreview", "rand01.pdf");
    }
  },
  mounted() {
    console.log("Mounted");
  }
};
</script>
